import { AuxDatePickerDateFormatEnum } from "@blk/aladdin-web-components";
export var Region;
(function (Region) {
    Region["enGB"] = "en-GB";
    Region["enUS"] = "en-US";
    Region["frFR"] = "fr-FR";
})(Region || (Region = {}));
export const regions = {
    [Region.enGB]: {
        datePickerDateFormat: AuxDatePickerDateFormatEnum.DD_MM_YYYY,
        defaultCurrency: "GBP",
        name: "English (United Kingdom)"
    },
    [Region.enUS]: {
        datePickerDateFormat: AuxDatePickerDateFormatEnum.MM_DD_YYYY,
        defaultCurrency: "USD",
        name: "English (United States)"
    },
    [Region.frFR]: {
        datePickerDateFormat: AuxDatePickerDateFormatEnum.DD_MM_YYYY,
        defaultCurrency: "EUR",
        name: "French (France)"
    }
};
